import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { AuthService } from './http-services/authservice.service';

@Injectable({
  providedIn: 'root'
})
export class ProctorService {

  constructor(private httpClient: HttpClient, private auth: AuthService) { }

  get headers() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Authorization', `Bearer ${this.auth.token}`);
    return headers;
  }

  async getExamProctors(tableParam) {
    return await lastValueFrom(this.httpClient.patch(
      `${env.apiURL}proctors/`,
      tableParam, { headers: this.headers }
    ), { defaultValue: [] });
  }
  async getProctorToken() {
    // This method retrieves a token for the proctor (flags and recordings)
    return this.httpClient.post(`${env.apiURL}proctors/token`, { headers: this.headers }).toPromise();
  }

}
